import { useEffect, useRef } from "react";
import { CalendarClock, ExternalLink } from "lucide-react";

const CALENDLY_URL =
  process.env.REACT_APP_CALENDLY_URL ||
  "https://calendly.com/goodliving-strategy/strategy-call";

export default function CalendlyWidget() {
  const containerRef = useRef(null);

  useEffect(() => {
    const id = "calendly-widget-script";
    if (!document.getElementById(id)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://assets.calendly.com/assets/external/widget.css";
      document.head.appendChild(link);

      const script = document.createElement("script");
      script.id = id;
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div data-testid="calendly-widget" className="w-full">
      <div
        ref={containerRef}
        className="calendly-inline-widget border border-gl-gold/20 bg-gl-bg"
        data-url={`${CALENDLY_URL}?hide_gdpr_banner=1&background_color=110e14&text_color=f7f5f2&primary_color=cba365`}
        style={{ minWidth: "320px", height: "680px" }}
      />
      <a
        href={CALENDLY_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="calendly-fallback-link"
        className="mt-4 inline-flex items-center gap-2 text-sm text-gl-gold hover:text-gl-goldHover transition-colors"
      >
        <CalendarClock size={16} />
        Booking widget not loading? Open it in a new tab
        <ExternalLink size={14} />
      </a>
    </div>
  );
}
